import "./App.css";
import Finder from "./components/Finder";
import { BrowserRouter as Router } from "react-router-dom";
function App() {
  return (
    <Router>
      <Finder />
    </Router>
  );
}

export default App;
